export default [
  '20001',
  '20004',
  '20005',
  '20007',
  '20008',
  '32003',
  '32008',
  '30004',
  '30001',
  '30002',
  '30003',
  '30005',
  '30006',
  '30009',
  '30010',
  '30011',
  '30014',
  '40001',
  '40003',
  '40004',
  '40005',
  '40010',
  '50001',
  '60001',
  '60006',
  '60008',
];
